import { QueovalBase } from "../global";

export class ELearningStageModel extends QueovalBase {

  public ColumnDefs: any[];
  public RowData: any[];
  public GridName: string;

}
